import React from 'react';
import Layout from './pages/Layout';

function App() {
  return (
    <div className="App">
      
      <Layout/>
    </div>
  );
}

export default App;
